import { IState } from '../../store';

export function getIsTooltipOpen(state: IState): boolean {
  return state.flatTourBooking.isTooltipOpen;
}
